// src/redux/settingsPages/security/securityAPI.js
import apiClient from '../../authentication/utils/core/axios';

const SecurityAPI = {
  async setupMfa() {
    const res = await apiClient.post('/mfa/setup');
    return res.data; // { qr_code, secret }
  },

  async verifyMfaSetup(code) {
    await apiClient.post('/mfa/verify-setup', { code });
    return true;
  },

  async disableMfa(code) {
    await apiClient.post('/mfa/disable', { code });
    return true;
  },
};

export default SecurityAPI;
